import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, SimpleChange} from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray} from '@angular/forms';
import { AccountService } from '../account.service';
import { Device } from '../models/kiosk';
import { timezones } from '../models/timezones';
import { Observable } from 'rxjs/Observable';
import { startWith, map } from 'rxjs/operators';
import { KioskService } from '../kiosk.service';

@Component({
  selector: 'app-kiosk-edit-tenants',
  templateUrl: './kiosk-edit-tenants.component.html',
  styleUrls: ['./kiosk-edit-tenants.component.css'],
})
export class KioskEditTenantsComponent implements OnInit, OnChanges {
  @Input() tenants: any[];
  @Output() tenantsChanged: EventEmitter<any> = new EventEmitter<any>();
  formGroup: FormGroup;
  toAddTenants: any[] = [];
  loading = false;

  constructor(
    private _fb: FormBuilder,
    private _accountService: AccountService,
    private _kioskService: KioskService
  ) {
    this.createForm();
  }

  ngOnInit() {
    console.log('ngOnInit')
    // this.setKiosk(this.kiosk);
    this.createForm();
    this.setTenants(this.tenants);

  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('changes', changes)
    const tenants: SimpleChange = changes.tenants;

    this.setTenants(tenants.currentValue);
  }

  getFormGroupControls() {
    return <FormArray>this.formGroup.get('tenants');
  }


  setTenants(tenants: any[]) {
    console.log('setting tenants', tenants)
    this.createForm();
    if (tenants) {

      tenants.forEach(el => {
        console.log('tenant:', el)
        const a = <FormArray>this.formGroup.controls['tenants'];

        const b = this.createFormTenant();
        b.get('account_id').setValue(el.account_id);
        b.get('id').setValue(el.id);
        b.get('folder_id').setValue(el.folder_id);
        this._kioskService.getFolder(el.folder_id).subscribe((folder: any) => {
          const ownerAccountID = folder.folder_relationships.find((x) => x.permission === 1).account_id;
          this._accountService.byId(ownerAccountID).subscribe((data) => {
            b.get('email').setValue(data.email);
          });
        });

        a.push(b);
      });
    }
  }

  createForm(): any {

    this.formGroup = this._fb.group({

      tenants: this._fb.array([], [Validators.minLength(1), Validators.maxLength(4)]),
    });
    console.log(this.formGroup)

    this.formGroup.valueChanges.subscribe((data) => {
      this.tenantsChanged.emit(data.tenants.filter((x) => !x.id));
    });
  }

  saveKiosk() {
    console.log('saving kiosk details');
  }

  inviteAccount(acc) {
    console.log('inviting account', acc);
    if (this.formGroup.get('tenants').value.filter((x: any) => x.account_id === acc.id).length === 0) {
      const a = <FormArray>this.formGroup.controls['tenants'];

      const b = this.createFormTenant();
      b.get('account_id').setValue(acc.id);
      b.get('email').setValue(acc.email);

      a.push(b);

      this.toAddTenants.push(b.value);
      this.tenantsChanged.emit(this.toAddTenants);
    }

  }

  createFormTenant(): FormGroup {
    return this._fb.group({
      email: ['', Validators.required],
      account_id: ['', Validators.required],
      folder_id: [0],
      id: [0],
      name: ['', Validators.required],
    });
  }

  removeMember(i: number) {
    const a = <FormArray>this.formGroup.controls['tenants'];
    a.removeAt(i);
  }

}




// WEBPACK FOOTER //
// ./src/app/kiosk-edit-tenants/kiosk-edit-tenants.component.ts